module.exports = __webpack_public_path__ + "static/media/massage-therapy-1612308_1280.6fba02f4.jpg";